import { useRef, useState } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";


import { MenuPai } from "../../typesSite/menuPai/MenuPai";
import useMenuPaiSiteFetch from "./useMenuPaiSiteFetch";


type Props = {
  isdisabled?: boolean;
  isLoading?: boolean;
  required?: boolean;
  value?: MenuPai | null;
  handleSearchChange: (newValue: MenuPai) => void;
};

const TxtMenuPaiSite = ({
  isdisabled,
  isLoading,

  required,
  value,
  handleSearchChange,
}: Props) => {
  const timeoutRef = useRef<number | null>(null);
  const loading = useRef(false);

  const handleSetLoad = (newValue: boolean) => {
    loading.current = newValue;
  };

  const [inputValue, setInputValue] = useState("");
  const { options } = useMenuPaiSiteFetch({ inputValue, handleSetLoad });

  return (
    <Autocomplete
      value={value && value.id ? value : null} //
      size="small"
      options={options}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => {
        const menuPaiSite = option as MenuPai;
        let descricao: string = "";
        if (!menuPaiSite) {
          return "";
        }

        if (menuPaiSite.label) {
          descricao = menuPaiSite.label;
        }

        //if (menuPaiSite.usuario?.cpf) {
        //    descricao = "(" + menuPaiSite.usuario.cpf + ") " + descricao;
        // }
        return descricao;
        //return menuPaiSite.descricao ? menuPaiSite.descricao : "";
      }}
      loading={loading.current}
      onInputChange={(event, newInputValue) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          setInputValue(newInputValue);
        }, 700); // 300ms delay
      }}
      onChange={(event, newValue) => {
        handleSearchChange(newValue as MenuPai);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Menu Principal - nível 1"
          required={required ? true : false}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading.current ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};
export default TxtMenuPaiSite;
